module.exports = __webpack_public_path__ + "img/ens-manager-new.3edc81eb.svg";